export default function OurStandards() {
  const standards = [{
    title: "Coordinating",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/arch_coordinating.png"
  }, {
    title: "Investing",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/arch_investing.png"
  }, {
    title: "Dominate",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/arch_dominate.png"
  }, {
    title: "Execution",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/arch_execution.png"
  }, {
    title: "Expertise",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/arch_expertise.png"
  }];
  return <section data-section-id="90269" id="our-foundation" className="bg-background text-foreground w-full flex flex-col font-sans">
      <div className="max-w-[800px] mx-auto px-4 py-16 md:py-24 w-full">
        <div className="flex flex-col items-start">
          <span className="text-[20px] font-normal leading-relaxed text-muted-foreground mb-8 font-sans">
            We are a premier holding company coordinating, investing in, and managing a strategic portfolio of logistical and digital assets designed to dominate complex international markets. Our power lies in flawless execution and local expertise.
          </span>
          <h2 className="text-5xl md:text-7xl font-bold text-foreground font-serif uppercase tracking-tight before:content-[''] before:inline-block before:w-1 before:h-1 before:bg-primary before:mr-4 before:mb-2">
            Our Foundation
          </h2>
        </div>
      </div>

      <div className="w-full h-[80vh] min-h-[600px] flex flex-col md:flex-row overflow-hidden border-t border-border/10">
        {standards.map((standard, i) => <div key={i} data-index={i} className="group relative flex-1 h-full transition-all duration-700 ease-out hover:flex-[1.2] md:hover:flex-[1.5] overflow-hidden cursor-pointer border-b md:border-b-0 md:border-r border-border/10 last:border-0">
            {}
            <div className="absolute inset-0 bg-background/80 group-hover:bg-background/20 transition-colors duration-700 z-10 backdrop-blur-[2px]" />
            
            {}
            <img src={standard.image} alt={standard.title} className="absolute inset-0 w-full h-full object-cover opacity-10 group-hover:opacity-40 transition-all duration-700 scale-110 group-hover:scale-100" />
            
            {}
            <div className="absolute inset-0 z-20 flex items-center justify-center p-4">
              <h3 className="text-foreground/80 font-bold text-xl md:text-2xl tracking-widest uppercase text-center md:[writing-mode:vertical-lr] md:rotate-180 font-serif transition-transform duration-500 group-hover:text-primary group-hover:scale-105">
                {standard.title}
              </h3>
            </div>
          </div>)}
      </div>
    </section>;
}